import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, map, Observable, of } from "rxjs";
import { AppConfig } from "../helpers/app.config";
import { Division } from "../interfaces/division";

@Injectable({ providedIn: "root" })
export class GridScenariosDataService {
  private readonly http = inject(HttpClient);

  private readonly getParams = (ags: string) => ({
    headers: new HttpHeaders({ "x-customer-name": ags })
  });

  readonly api = AppConfig.connection.backendForFrontend.module00022;

  createDefaultScenario(division: Division, ags: string): Observable<void | Error> {
    return this.http.post<unknown>(`${this.api}/scenarios/default`, { type: division }, this.getParams(ags)).pipe(
      map(() => undefined),
      catchError(() => of(new Error("CreateDefaultScenarioError")))
    );
  }
}
